import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Card, Alert, InputGroup, Modal } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "./style/Login.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import AddImage1 from "./assets/img/latte1.png";
import { auth } from ".././firebase";
import {getAuth, sendPasswordResetEmail } from "firebase/auth";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { login, currentUser, logout } = useAuth();
  const [error, setError] = useState("");
  const [errorReset, setErrorReset] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [loadingReset, setLoadingReset] =useState(false)
  document.title ='Login - Hentian Komuniti';

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      const user = await login(
        emailRef.current.value,
        passwordRef.current.value
      );
      if(user.emailVerified === false){
        logout();
        setError("Please check your inbox and verify your email before login.")
        setLoading(false)
        return;
      }
      const docRef = doc(db, "merchants", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data().name);
        const userString = JSON.stringify(user);
        const userDetail = JSON.stringify(docSnap.data());
        sessionStorage.setItem("currentUser", userString);
        sessionStorage.setItem("currentUserDetail", userDetail);
        navigate("/dashboard");
      } else {
        setError("Failed to login. Please make sure you have merchant account");
        console.log("No such document!", currentUser.uid);
        logout();
      }
    } catch (error) {
      console.log(error);
      setError("Failed to login. Please check your email and password");
    }
    setLoading(false);
  }
  const handleResetPassword = async () => {
    setLoadingReset(true);
    // Send password reset email using Firebase
    if(!email){
        setErrorReset("Email should not be empty");
        setLoadingReset(false)
        return;
    }
    const auth = getAuth();
    sendPasswordResetEmail(auth, email)
      .then(() => {
        alert("Password reset email sent. Please check your inbox.");
        setShowModal(false);
      })
      .catch((error) => {
        console.error("Error sending reset email:", error.message);
        // Display an error message to the user
        setErrorReset("Failed to send password reset email. Please try again.");
      });
    setLoadingReset(false);
  };

  const closeModal = async () => {
    setErrorReset("");
    setShowModal(false);
    setLoadingReset(false);
    setEmail("")
  };
  return (
    <div className="body">
      <div className="row body">
        <div className="col-12 col-sm-6 d-flex justify-content-center align-items-center custom-container">
          <Card className="border-0 card">
            <h3 className="text-center title">Login As Merchant</h3>
            <Card.Body>
              <h6 className="mt-5">Sign In</h6>
              <Form onSubmit={handleSubmit}>
                <Form.Group id="email" className="my-3">
                  <InputGroup>
                    <InputGroup.Text className="custom-input">
                      <i className="bi bi-envelope-fill"></i>
                    </InputGroup.Text>
                    <Form.Control
                      className="custom-input"
                      type="email"
                      ref={emailRef}
                      required
                      placeholder="Email *"
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group id="password" className="my-3 ">
                  <InputGroup>
                    <InputGroup.Text className="custom-input">
                      <i className="bi bi-lock-fill"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="password"
                      className="custom-input"
                      ref={passwordRef}
                      required
                      placeholder="Password *"
                    />
                  </InputGroup>
                </Form.Group>
                {error && <Alert variant="danger mt-2">{error}</Alert>}
                <div>
                  <div className="row">
                    <div className="col-6">
                      <Button
                        disabled={loading}
                        id="loginBtn"
                        type="submit"
                        className={` mt-2 ${loading ? "disabled" : ""}`}
                      >
                        LOGIN <i className="bi bi-arrow-right"></i>
                      </Button>
                    </div>
                    <div className="col-6 d-flex justify-content-center align-items-center">
                      <h6
                        className="text-small mt-3 forgot-password"
                        onClick={() => setShowModal(true)}
                      >
                        Forgot password?{" "}
                      </h6>
                    </div>
                  </div>
                </div>
              </Form>
              <div className="text-center mt-5">
                <Link to="/signup">
                  <Button className="newAccountBtn">CREATE NEW ACCOUNT</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </div>

        <div className="right-side col-0 d-none d-sm-flex col-sm-6 right-login d-flex justify-content-center align-items-center">
          <div className="box p-3">
            <div className="mt-4 green-login-box"></div>
            <div className="text-box mt-3">
              <h3 className="font-weight-bold">Hentian Komuniti</h3>
              <h5>SS15, Subang Jaya</h5>
            </div>
            <img className="icon-img" src={AddImage1}></img>
            <div className="green-line"></div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title><span><i class="bi bi-shield-lock-fill me-2 icon"></i></span>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formResetPassword">
            <Form.Label>Enter your email to reset password:</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          {errorReset && <Alert variant="danger mt-2">{errorReset}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
          <Button
          id="button-active"
          className="custom-button"
            variant="primary"
            onClick={handleResetPassword}
            disabled={loadingReset}
          >
            Reset Password
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
